import React, { cloneElement } from 'react';
import classNames from 'classnames';
import { Props as InputMaskProps } from 'react-input-mask';

const InputField = React.forwardRef<HTMLInputElement, InputFieldProps>(
  (
    { id, label, addon, helperText, className, InputComponent, ...props },
    ref,
  ) => {
    return (
      <div className="form-group">
        <div className="input-addon">
          <span className="input-floating">
            {cloneElement(InputComponent, {
              className: classNames('input', className),
              placeholder: label,
              id,
              ref,
              ...props,
            })}
            <label htmlFor={id}>{label}</label>
            {addon}
          </span>
        </div>
        {helperText}
      </div>
    );
  },
);

export interface InputFieldProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  id: string;
  label: string;
  InputComponent: React.ReactElement<
    (InputMaskProps | React.InputHTMLAttributes<HTMLInputElement>) &
      React.RefAttributes<HTMLInputElement>
  >;
  addon?: React.ReactNode;
  helperText?: React.ReactNode;
}

export default InputField;
